module.exports = __webpack_public_path__ + "img/tutorial_guideChat_02.4450a335.jpg";